module.exports = "/_next/static/images/Hero@2x-b62f877a0cc4b04ba4f0734653e98dae.webp";